<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">ออกงานเรียบร้อยแล้ว</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_summarize_add === true">สรุปการออกงานเรียบร้อยแล้ว</v-alert>
    </v-slide-x-reverse-transition>
    <h2>วันที่ {{ date }}</h2>
    <v-card>
        <div class="mb-2">
            <v-tabs grow>
                <v-tab @click="page(title_detail.shifts_id)" v-for="(title_detail,index) in title_list" :key="index">{{ title_detail.shift_name }}</v-tab>
            </v-tabs>
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <div v-for="(detail_shift,index) in data" :key="index">
                    <v-simple-table v-if="title_type_timework == detail_shift.shifts_id">
                        <thead>
                            <tr>
                                <th class="text-center border_detail_report_work_list">
                                    #
                                </th>
                                <th class="text-center border_detail_report_work_list">
                                    ชื่อพนักงาน
                                </th>
                                <th class="text-center border_detail_report_work_list">
                                    เวลาเข้างาน
                                </th>
                                <th class="text-center border_detail_report_work_list">
                                    การออกงาน
                                </th>
                                <th class="text-center border_detail_report_work_list">
                                    OT (ชั่วโมง)
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="(detail_employee,index_employee) in detail_shift.employee" :key="index_employee">
                            <tr>
                                <td class="text-center border_detail_report_work_list">
                                    <div class="pa-2">
                                        {{ index_employee + 1 }}
                                    </div>

                                </td>
                                <td class="text-center border_detail_report_work_list">
                                    <div class="pa-2">
                                        {{ detail_employee.employee_name }}
                                    </div>

                                </td>
                                <td class="text-center border_detail_report_work_list">
                                    <div class="pa-2">
                                        {{ detail_employee.start_work ? detail_employee.start_work : '-' }}
                                    </div>

                                </td>
                                <td class="text-center border_detail_report_work_list" width="20%">
                                    <div class="pa-2" v-if="detail_employee.out_work">
                                        {{ detail_employee.out_work}}
                                    </div>
                                    <div class="pa-2" v-if="!detail_employee.out_work">
                                        -
                                    </div>

                                </td>
                                <td class="text-center border_detail_report_work_list" width="20%">
                                    <div class="pa-2" v-if="$route.path == '/editreportwork'">
                                        <v-text-field type="number" v-model="detail_employee.ot" hide-details="auto" dense outlined></v-text-field>
                                    </div>
                                    <div class="pa-2" v-if="$route.path == '/detailreportwork'">
                                        {{ detail_employee.ot ? detail_employee.ot : '-' }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </div>
        </div>
    </v-card>
    <div v-if="$route.path == '/editreportwork'">
        <v-btn width="100%" height="50" @click="reportWorkUpdate()">สรุปงาน</v-btn>
    </div>

</div>
</template>

<script>
import reportwork from '@/api/team/teamreportsummary/reportwork.js'
import outtimework from '@/api/team/teaminouttimework/outtimework.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            alert_show_summarize_add: false,
            date: null,
            title_type_timework: null,
            title_list: [],
            data: [],
        }
    },
    methods: {
        async detailReportwork() {
            this.loading_page = true
            this.title_list = []
            this.data = []
            let date_reportwork = null
            if (this.$route.path == '/detailreportwork') {
                date_reportwork = this.$store.state.detailReportWorkDate
            }
            if (this.$route.path == '/editreportwork') {
                date_reportwork = this.$store.state.editReportWorkDate
            }

            reportwork.detailReportWork(date_reportwork).then((response) => {
                if (response.data.successful === true) {
                    let date_reportwork_list = date_reportwork.split("-")
                    let date_reportwork_month = date_reportwork_list[1] - 1
                    const date = new Date(date_reportwork_list[0],date_reportwork_month, date_reportwork_list[2])
                    this.date = date.toLocaleDateString('th-TH', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                    })
                    response.data.workTimeList.forEach((detail, index) => {
                        if (index == 0 && this.title_type_timework == null) {
                            this.title_type_timework = detail.shifts_id
                        }
                        this.title_list.push({
                            shifts_id: detail.shifts_id,
                            shift_name: detail.shift_name,
                        })
                    })

                    this.data = response.data.workTimeList
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page(type) {
            this.title_type_timework = type
        },
        async reportWorkUpdate() {
            this.loading_page = true
            let work_time_id = []
            let work_type = []
            let ot = []
            this.data.forEach((detail_shifts) => {
                detail_shifts.employee.forEach((detail_employee) => {
                    let ot_employee = detail_employee.ot
                    if (ot_employee == '') {
                        ot_employee = null
                    }
                    work_time_id.push(detail_employee.work_time_id)
                    work_type.push(detail_employee.work_type)
                    ot.push(ot_employee)
                })
            })
            const data = {
                work_time_id: work_time_id,
                work_type: work_type,
                ot: ot,
            }
            outtimework.workTimeOutUpdate(data).then((response) => {
                if (response.data.successful === true) {
                    this.detailReportwork()
                    this.alert_show_summarize_add = true
                    setTimeout(() => this.alert_show_summarize_add = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },

    mounted() {
        this.detailReportwork()
    }
}
</script>

<style scoped>
.border_detail_report_work_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
